export enum ETheme {
  /** 黑暗模式 */
  DARK = 'dark',
  /** 普通模式 */
  LIGHT = 'light',
  /** 跟随系统 */
  AUTO = 'auto',
}
